import { useFormContext } from 'react-hook-form';
import '../css/setChamfer.css';

const PATH_IMG = process.env.REACT_APP_IMG_URL;

export default function SetChamfer({ initChamfers }) {
    const { register } = useFormContext();

    return (
        <>
            <div className="step-title">
                <h2 className="num-step-title">4</h2>
                <h2>Выбор фаски:</h2>
            </div>
            <div className="edges">
                {initChamfers.map((chamfer) => (
                    <div key={chamfer.type}>
                        <label htmlFor={chamfer.type}>
                            <p>тип {chamfer.type}</p>
                            <img src={PATH_IMG + chamfer.image} alt={'фаска кромка ' + chamfer.type} />
                            <input id={chamfer.type} type="radio" {...register('chamfer')} value={chamfer.type} />
                        </label>
                    </div>
                ))}
            </div>
        </>
    );
}
